import { Inbox } from 'lucide-react'

export default function EmptyState({ message = 'No data found' }: { message?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-gray-400">
      <Inbox className="w-10 h-10 mb-3" />
      <p className="text-sm">{message}</p>
    </div>
  )
}
